var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 secondary-text text-center"},[_vm._v("\n  Step "+_vm._s(_vm.stepNumber)+" of "+_vm._s(_vm.drivewealthWizard.numberOfWizardSteps)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }